/* ORVANE9 theme scripts */
(function () {
  'use strict';

  /* ---------- Announcement rotation ---------- */
  document.querySelectorAll('[data-announcement]').forEach(function (track) {
    var items = track.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* ---------- Mobile menu ---------- */
  var drawer = document.querySelector('[data-menu-drawer]');
  var openBtn = document.querySelector('[data-menu-open]');
  var closeBtn = document.querySelector('[data-menu-close]');
  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
  }
  if (drawer && openBtn) {
    openBtn.addEventListener('click', function () {
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      openBtn.setAttribute('aria-expanded', 'true');
    });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    drawer.addEventListener('click', function (e) { if (e.target === drawer) closeDrawer(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---------- Money ---------- */
  function money(cents) {
    var yen = Math.round(cents / 100);
    return '¥' + yen.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---------- Product form ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add-button]');
    var addLabel = root.querySelector('[data-add-label]');
    var priceWrap = root.querySelector('[data-price-wrapper]');
    var mainImg = root.querySelector('.product__main-img');
    var radios = root.querySelectorAll('input[data-option-index]');
    var labels = { sold: '売り切れ', add: 'カートに追加' };
    if (addLabel) labels.add = addLabel.textContent.trim() === labels.sold ? labels.add : addLabel.textContent.trim();

    function selectedOptions() {
      var opts = [];
      radios.forEach(function (r) { if (r.checked) opts[Number(r.dataset.optionIndex)] = r.value; });
      return opts;
    }

    function setImage(src) {
      if (!mainImg || !src) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = src;
    }

    function renderPrice(v) {
      if (!priceWrap) return;
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      var html = '';
      if (onSale) html += '<s class="price__compare">' + money(v.compare_at_price) + '</s>';
      html += '<span class="price__current">' + money(v.price) + '</span>';
      html += '<span class="price__tax">(税込)</span>';
      var showBadge = priceWrap.dataset.badge === '1';
      if (onSale && showBadge) {
        var pct = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        html += '<span class="price__badge" data-sale-badge>' + pct + '%OFF</span>';
      }
      priceWrap.classList.toggle('price--on-sale', !!onSale);
      priceWrap.innerHTML = html;
    }

    function update() {
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      opts.forEach(function (val, i) {
        var lbl = root.querySelector('[data-option-label="' + i + '"]');
        if (lbl) lbl.textContent = val;
      });
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = '販売停止中';
        return;
      }
      idInput.value = variant.id;
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? labels.add : labels.sold;
      renderPrice(variant);
      if (variant.featured_media) {
        var thumb = root.querySelector('[data-thumb][data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) { activateThumb(thumb); }
        else if (variant.featured_image) { setImage(variant.featured_image.src); }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function activateThumb(btn) {
      root.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      setImage(btn.dataset.src);
    }

    radios.forEach(function (r) { r.addEventListener('change', update); });
    root.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () { activateThumb(btn); });
    });

    /* quantity */
    var qty = root.querySelector('[data-qty-input]');
    if (qty) {
      var max = qty.max ? Number(qty.max) : Infinity;
      root.querySelector('[data-qty-minus]').addEventListener('click', function () {
        qty.value = Math.max(1, Number(qty.value || 1) - 1);
      });
      root.querySelector('[data-qty-plus]').addEventListener('click', function () {
        qty.value = Math.min(max, Number(qty.value || 1) + 1);
      });
      qty.addEventListener('change', function () {
        var n = Math.max(1, Math.min(max, Number(qty.value) || 1));
        qty.value = n;
      });
    }
  });

  /* ---------- Related products ---------- */
  document.querySelectorAll('[data-related]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-related]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });
})();
